export default {
  Title: 'Cập nhật tài khoản sau sao chép',
  CreditAccount: 'TK Nợ',
  CreditAccountTooltip: 'Tài khoản Nợ',
  DebitAccount: 'TK Có',
  DebitAccountTooltip: 'Tài khoản Có',
  Cancel: 'Hủy bỏ',
};
